import styled from 'styled-components';

export const StyledItemWithBadge = styled.div`
  position: relative;
`;

export const StyledBadgeNotification = styled.div`
  min-width: 25px;
  height: 25px;
  padding: 0 8px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  text-align: center;
  white-space: nowrap;
  background: linear-gradient(40deg,rgb(39,118,97) -20%,rgb(35 204 159) 70%);
  border-radius: 14px;
  z-index: auto;
  overflow: hidden;
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-12px);
`;
